/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetDetailComponentControllerResponseDto
 */
export interface AssetDetailComponentControllerResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDetailComponentControllerResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailComponentControllerResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailComponentControllerResponseDto
     */
    ocppId: string | null;
}

/**
 * Check if a given object implements the AssetDetailComponentControllerResponseDto interface.
 */
export function instanceOfAssetDetailComponentControllerResponseDto(value: object): value is AssetDetailComponentControllerResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ocppId' in value) || value['ocppId'] === undefined) return false;
    return true;
}

export function AssetDetailComponentControllerResponseDtoFromJSON(json: any): AssetDetailComponentControllerResponseDto {
    return AssetDetailComponentControllerResponseDtoFromJSONTyped(json, false);
}

export function AssetDetailComponentControllerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDetailComponentControllerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'ocppId': json['ocppId'],
    };
}

export function AssetDetailComponentControllerResponseDtoToJSON(json: any): AssetDetailComponentControllerResponseDto {
    return AssetDetailComponentControllerResponseDtoToJSONTyped(json, false);
}

export function AssetDetailComponentControllerResponseDtoToJSONTyped(value?: AssetDetailComponentControllerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'ocppId': value['ocppId'],
    };
}

